import axios from 'axios';

export const getTickerData = async () => {
  try {
    const res = await axios.get('/ticker/data');
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const getXMLData = async () => {
  try {
    const res = await axios.get('/ticker/data/getXML');
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const getTemplates = async () => {
  try {
    const res = await axios.get(`/templates`);
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const getTemplatesData = async () => {
  try {
    const res = await axios.get(`/templatedata`);
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const getTemplatesHTML = async (filename) => {
  try {
    const res = await axios.get(`/templates/${filename}`);
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const createMessage = async (data) => {
  try {
    const res = await axios({
      method: 'POST',
      url: '/ticker/data/message',
      data,
    });
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const createMessageData = async (data) => {
  try {
    const res = await axios({
      method: 'POST',
      url: '/ticker/data/messagedata',
      data,
    });
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const editMessage = async (data, id) => {
  try {
    const res = await axios({
      method: 'PUT',
      url: `/ticker/data/message/${id}`,
      data,
    });
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const updateMessageStatus = async (data) => {
  try {
    const res = await axios({
      method: 'PUT',
      url: `/ticker/data/message/status`,
      data,
    });
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const updateMessagePosition = async (data) => {
  try {
    const res = await axios({
      method: 'PUT',
      url: `/ticker/data/message/position`,
      data,
    });
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const editMessageOrder = async (data) => {
  try {
    const res = await axios({
      method: 'PUT',
      url: `/ticker/data/message/order`,
      data,
    });
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const editMessageData = async (data) => {
  try {
    const res = await axios({
      method: 'PUT',
      url: `/ticker/data/msgdata`,
      data,
    });
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const deleteMessage = async (id) => {
  try {
    const res = await axios({
      method: 'DELETE',
      url: `/ticker/data/message/${id}`,
    });
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

// export const deleteMessages = async (ids) => {
//   try {
//     const res = await axios.delete('/ticker/data/messages', { data: {ids}  });
//     return res.data;
//   } catch (error) {
//     throw new Error(`${error.message} - ${error.response?.data}`);
//   }
// };
export const deleteMessages = async (ids) => {
  try {
    const res = await axios({
      method: 'POST',
      url: `/ticker/data/delete_messages`,
      data: {ids}
    });
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const editCarousel = async (data, id) => {
  try {
    const res = await axios({
      method: 'PUT',
      url: `/ticker/data/carousel/${id}`,
      data,
    });
    return res.data;
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};

export const createPreview = async (data) => {
  try {
    const res = await axios({
      method: 'POST',
      url: '/ticker/preview',
      data,
    });
    return res.data;
    
  } catch (error) {
    throw new Error(`${error.message} - ${error.response?.data}`);
  }
};